import React from 'react';

export default function DocumentValidationHeader() {
  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Validasi Kelengkapan Dokumen</h1>
      <p className="text-gray-500 mt-1">Monitor kelengkapan dokumen wajib debitur</p>
    </div>
  );
}
